import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface errorState {
  message: string;
  redirectUrl: string;
  isError: boolean;
}

const initialErrorState: errorState = {
  message: '',
  redirectUrl: '',
  isError: true,
};

const errorSlice = createSlice({
  name: 'error',
  initialState: initialErrorState,
  reducers: {
    setErrorMessage: (state, action: PayloadAction<string>) => {
      state.message = action.payload;
    },
    setErrorRedirectUrl: (state, action: PayloadAction<string>) => {
      state.redirectUrl = action.payload;
    },
    setErrorIsError: (state, action: PayloadAction<boolean>) => {
      state.isError = action.payload;
    },
  },
});

export const { setErrorMessage, setErrorRedirectUrl, setErrorIsError } =
  errorSlice.actions;

export default errorSlice.reducer;
